export default {
  form: {
    organization_name: 'School/Organization Name',
    student_name: 'Student Name',
    phone_number: 'Phone Number',
    email: 'Email Address',
    content: 'Inquiry Content',
    order_id: 'Order Number',
  },
  button: {
    submit: 'Submit',
  },
  message: {
    success: 'Your inquiry has been submitted successfully.',
    error: 'An error occurred. Please try again.',
  },
};
